import type { FC } from 'react'
import type { LinePaymets } from '../../interfaces'

import classNames from 'classnames'

interface IButtonGrid {
  record: LinePaymets
  choseSure: (fileNames: string, groupNumber: string, type: string, entId: string) => void
  isSure: boolean
  eventVoid: (fileNames: string, groupNumber: string) => void
  isPending?: boolean
}

const Avoid: FC<IButtonGrid> = ({ choseSure, isSure, eventVoid, isPending, record }) => {
  const typeButton = 'Avoid'
  const classList = classNames('void', { 'void-right': isSure })
  return (
    <button
      disabled={isPending}
      onClick={
        isSure
          ? () => {
              eventVoid(record.filenamesList, record.groupNumber)
            }
          : () => {
              choseSure(record.filenamesList, record.groupNumber, typeButton, record.entId)
            }
      }
      className={classList}
    >
      {isSure ? 'Right?' : 'Void'}
    </button>
  )
}

export default Avoid
